import { View, Text } from '@react-pdf/renderer';
import { QuestionarioItem } from '../../../types';
import { checklistStyles } from './styles';
import { formatters } from './formatters';

interface AnswerRendererProps {
  item: QuestionarioItem;
}

export function AnswerRenderer({ item }: AnswerRendererProps) {
  const renderAnswer = () => {
    switch (item.answerType) {
      case 'ShortAnswer':
      case 'LongAnswer':
      case 'YesNo':
      case 'RadioButton':
        return <Text style={checklistStyles.answerText}>{item.resposta || 'N/A'}</Text>;

      case 'Checkbox':
        return (
          <View>
            {item.respostas?.map((opcao: string, idx: number) => (
              <View key={idx} style={{ flexDirection: 'row', marginBottom: 2 }}>
                <Text style={{ fontSize: 8, color: '#0090FF', marginRight: 4 }}>✓</Text>
                <Text style={checklistStyles.answerText}>{opcao}</Text>
              </View>
            )) || <Text style={checklistStyles.answerText}>Nenhuma opção selecionada</Text>}
          </View>
        );

      case 'Date':
        return <Text style={checklistStyles.answerText}>{formatters.formatDate(item.data)}</Text>;

      case 'NumericInteger':
      case 'NumericDecimal':
        return <Text style={checklistStyles.answerText}>{formatters.formatNumber(item.valor)}</Text>;

      case 'Currency':
        return <Text style={checklistStyles.answerText}>{formatters.formatCurrency(item.valor)}</Text>;

      case 'File':
        if (!item.files || item.files.length === 0) {
          return <Text style={checklistStyles.answerText}>Nenhum arquivo anexado</Text>;
        }
        return (
          <View style={{ marginTop: 2 }}>
            <Text style={{ fontSize: 7.5, color: '#000000', marginBottom: 2 }}>
              Arquivos anexados ({item.files.length}):
            </Text>
            {item.files.map((file: any, idx: number) => (
              <View key={idx} style={checklistStyles.fileItem}>
                <Text style={checklistStyles.fileBullet}>•</Text>
                <Text style={checklistStyles.fileName}>{file.fileName}</Text>
              </View>
            ))}
          </View>
        );

      case 'Photo':
        return null;

      case 'Table': {
        const tableData = (item as any).tableData || [];
        if (!tableData.length) {
          return <Text style={checklistStyles.answerText}>Nenhum dado na tabela</Text>;
        }

        const columnNames = Object.keys(tableData[0]?.columns || {});
        if (!columnNames.length) {
          return <Text style={checklistStyles.answerText}>Tabela sem colunas</Text>;
        }

        return (
          <View style={{ marginTop: 2 }}>
            {/* Header */}
            <View style={{ flexDirection: 'row', height: 16, paddingHorizontal: 4, backgroundColor: '#F5F6F9', alignItems: 'center' }}>
              {columnNames.map((col, i) => (
                <Text key={i} style={{ flex: 1, fontSize: 7, fontWeight: 'bold', color: '#000000', textAlign: 'center' }}>{col}</Text>
              ))}
            </View>
            {/* Rows */}
            {tableData.map((row: any, rowIdx: number) => (
              <View key={rowIdx} style={{ flexDirection: 'row', height: 16, paddingHorizontal: 4, backgroundColor: rowIdx % 2 === 0 ? '#FFFFFF' : '#F5F6F9', alignItems: 'center' }}>
                {columnNames.map((col, i) => (
                  <Text key={i} style={{ flex: 1, fontSize: 7, color: '#000000', textAlign: 'center' }}>{row.columns?.[col] || '-'}</Text>
                ))}
              </View>
            ))}
          </View>
        );
      }

      default:
        return <Text style={checklistStyles.answerText}>[Tipo não suportado]</Text>;
    }
  };

  return (
    <View style={checklistStyles.answerContainer}>
      {renderAnswer()}
    </View>
  );
}
